__turbopack_context__.v({
  "cta": "BlockSubcategoryProductSlider-module-scss-module__5jMSYG__cta",
  "description": "BlockSubcategoryProductSlider-module-scss-module__5jMSYG__description",
  "fade-in": "BlockSubcategoryProductSlider-module-scss-module__5jMSYG__fade-in",
  "inner": "BlockSubcategoryProductSlider-module-scss-module__5jMSYG__inner",
  "navigation": "BlockSubcategoryProductSlider-module-scss-module__5jMSYG__navigation",
  "newBadge": "BlockSubcategoryProductSlider-module-scss-module__5jMSYG__newBadge",
  "nextButton": "BlockSubcategoryProductSlider-module-scss-module__5jMSYG__nextButton",
  "prevButton": "BlockSubcategoryProductSlider-module-scss-module__5jMSYG__prevButton",
  "productCard": "BlockSubcategoryProductSlider-module-scss-module__5jMSYG__productCard",
  "productsContainer": "BlockSubcategoryProductSlider-module-scss-module__5jMSYG__productsContainer",
  "productsScroll": "BlockSubcategoryProductSlider-module-scss-module__5jMSYG__productsScroll",
  "productsWrapper": "BlockSubcategoryProductSlider-module-scss-module__5jMSYG__productsWrapper",
  "row": "BlockSubcategoryProductSlider-module-scss-module__5jMSYG__row",
  "sidebar": "BlockSubcategoryProductSlider-module-scss-module__5jMSYG__sidebar",
  "title": "BlockSubcategoryProductSlider-module-scss-module__5jMSYG__title",
});
